// extracted by mini-css-extract-plugin
module.exports = {"bg":"index-bg-2uVtZ","popMiniModalRoot":"index-popMiniModalRoot-1yJvg","content":"index-content-2-t16","qrCodeCover":"index-qrCodeCover-21oeM","closeBtn":"index-closeBtn-1TpiL"};